import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Role } from '../../types';

const { Navigate, Outlet, useLocation } = ReactRouterDOM as any;

/** Routes accessibles sans vérification email (évite boucle de redirection) */
const SKIP_EMAIL_VERIFY_PATHS = [
  '/verify-email',
  '/verify-phone',
  '/login',
  '/register',
  '/logout',
  '/forgot-password',
  '/reset-password',
  '/oauth/callback',
];

function pathMatchesSkip(pathname: string): boolean {
  return SKIP_EMAIL_VERIFY_PATHS.some((p) => pathname === p || pathname.startsWith(p + '/'));
}

export const RequireEmailVerified: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const pathname = location?.pathname ?? '';

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (pathMatchesSkip(pathname)) return <Outlet />;

  // Seuls les clients doivent confirmer l'email (les admins peuvent ne pas avoir le champ)
  if (user.role !== Role.CLIENT) return <Outlet />;

  // Comptes de test Google Play Store : accès direct sans vérification email
  if (user.is_play_store_test_account === true) return <Outlet />;

  const emailVerified = user.email_verified === true;
  if (emailVerified) return <Outlet />;

  return <Navigate to="/verify-email" replace />;
};
